var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#3E436D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3337 24.1667C28.3337 24.6087 28.1581 25.0326 27.8455 25.3452C27.5329 25.6577 27.109 25.8333 26.667 25.8333H15.6903C15.2483 25.8334 14.8245 26.0091 14.512 26.3217L12.677 28.1567C12.5942 28.2394 12.4888 28.2957 12.3741 28.3186C12.2593 28.3414 12.1404 28.3297 12.0322 28.2849C11.9241 28.2401 11.8317 28.1643 11.7667 28.067C11.7017 27.9697 11.667 27.8553 11.667 27.7383V14.1667C11.667 13.7246 11.8426 13.3007 12.1551 12.9882C12.4677 12.6756 12.8916 12.5 13.3337 12.5H26.667C27.109 12.5 27.5329 12.6756 27.8455 12.9882C28.1581 13.3007 28.3337 13.7246 28.3337 14.1667V24.1667Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.0bf3d132367a1e37fb866283c7f72f5a.svg";
export { ForwardRef as ReactComponent };